import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGroupChatContext } from '../../context/groupchatContext';
import { updateAxiosAuth } from '../../helpers/setupAxios';

const ProviderLandingPage = () => {

    const groupChatContext = useGroupChatContext();
    const navigate = useNavigate();

    const {setAuthData} = useMemo(() => ({
        setAuthData: groupChatContext.setAuthData
    }));

    const data = new URLSearchParams(window.location.search).get('data');

    useEffect(()=>{
        if(data){
            const parsedData = JSON.parse(data);
            localStorage.clear();
            localStorage.setItem('base_url', JSON.stringify(parsedData.organization_setting));
            localStorage.setItem('auth', JSON.stringify(parsedData));
            updateAxiosAuth(parsedData, setAuthData);
            setAuthData(parsedData);
            navigate('/')
        }
    }, [data, navigate, setAuthData])

    return (
        <div className="flex justify-center items-center h-screen">
            <p className="text-xl">Loading...</p>
        </div>
    );
};

export default ProviderLandingPage;
